module.exports = __webpack_public_path__ + "a09468259a694aeeaf2a1f91655d412f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/harvard_university_2_2023_chart.png
// module id = 1683
// module chunks = 0